import { render } from "./TicketPaymentSuccess.vue?vue&type=template&id=32063a5e&scoped=true"
import script from "./TicketPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./TicketPaymentSuccess.vue?vue&type=script&lang=js"

import "./TicketPaymentSuccess.vue?vue&type=style&index=0&id=32063a5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32063a5e"]])

export default __exports__